export default function or<T>(predicates: Array<Predicate<T>>) {
  return function _or(val: T): boolean {
    return predicates.some((p) => p(val));
  };
}
